import { gql } from '@apollo/client'

import { FRAGMENT_INTERVIEWER_FULL } from './interviewerFragment'

export const FRAGMENT_CANDIDATE_FULL = gql`
  fragment FragmentCandidateFull on Candidate {
    id
    status
    interviewBookUrl
    uploadedCv
    isReadyForInterview
    noticePeriod
    moderationComment
    experience

    CandidateSkills {
      skillName
      publicName
      icon
      CandidateSkillSteps {
        skillName
        stepNumber
        stepType
        versionNumber
        scorePercent
        requireScore
        retryAfter
        passed
        finishedAt
        url
        sessionSkillGuid
        blocked
      }
    }

    InterviewSession {
      joinUrl
      rescheduleUrl
      scheduledAt
      Interviewer {
        ...FragmentInterviewerFull
      }
    }
  }

  ${FRAGMENT_INTERVIEWER_FULL}
`
